export default {
    methods: {
        moneyFormat: function (price) {
            return '£' + (price ? price: 0).toFixed(2);
        }
    }
}